export const computeProgression = (oldValue: number, newValue: number): string => {
     
    const value = Math.round(((newValue - oldValue) / oldValue) * 100);

    return `${value > 0 ? '+' : ''}${value}%`;
};
